import { useEffect, useState } from 'react'
import {
  fetchAndActivateRemoteConfig,
  getMedicalRecordChatEnabledFromRemote,
} from 'configs/firebase'

/**
 * `true` até o fetch do Remote Config concluir; depois reflete
 * `medical_record_chat_enabled` (padrão: true se a rede falhar).
 */
export function useMedicalRecordChatEnabled(): boolean {
  const [enabled, setEnabled] = useState(true)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      await fetchAndActivateRemoteConfig()
      if (cancelled) return
      setEnabled(getMedicalRecordChatEnabledFromRemote())
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return enabled
}
